import { initialState } from "./slice";
import { createSelector } from "reselect";

export const selectEditor = (state) => state.editor || initialState;

export const selectPoints = createSelector(
  selectEditor,
  (editorState) => editorState.points
);

export const selectRectangles = createSelector(
  selectEditor,
  (editorState) => editorState.rectangles
);

export const selectCurrentPointerMode = createSelector(
  selectEditor,
  (editorState) => editorState.currentPointerMode
);

export const selectActiveObjectId = createSelector(
  selectEditor,
  (editorState) => editorState.activeObjectId
);

export const selectActiveDetectedFieldId = createSelector(
  selectEditor,
  (editorState) => editorState.activeDetectedFieldId
);

export const selectCurrentDrawingRectangle = createSelector(
  selectEditor,
  (editorState) => editorState.currentDrawingRectangle
);

export const selectCurrentActiveRectangleData = createSelector(
  selectActiveObjectId,
  selectRectangles,
  (activeId, rectangles) => {
    const activeItem = rectangles.find((item) => item.id === activeId);

    if (activeItem) {
      return activeItem.fieldProperties.rectangle;
    } else {
      return null;
    }
  }
);

export const selectSettingColors = createSelector(
  selectEditor,
  (editorState) => editorState.settingColors
);

export const settingObjectDefaultSizes = createSelector(
  selectEditor,
  (editorState) => editorState.settingObjectDefaultSizes
);
